






















































import { Component, Prop } from 'vue-property-decorator';
import Draggable from 'vuedraggable';

import CommonVue from '../../models/commonVue';
import { BusEvent } from '@/models/bus';
import LockManager from '@/models/lock';

import { ExerciseGameType } from '../../api/common';
import ApiList from '../../api/list';
import Lesson from '@/api/lesson';
import Exercise from '../../api/exercise';

import EditIcon from '@/components/icons/EditIcon.vue';

@Component({
  components: {
    draggable: Draggable,
    'edit-icon': EditIcon
  }
})
export default class ListExercise extends CommonVue {
  @Prop({ type: Number }) public moduleId!: number;
  @Prop({ type: Lesson }) public lesson!: Lesson;
  @Prop() public parent?: string;

  public exercises: ApiList<Exercise> = null;

  public exerciseDragOptions: object = {
    group: 'submodule',
    ghostClass: 'ghost'
  };
  public draggedElement: Exercise = null;
  public moving: boolean = false;

  public async beforeMount() {
    this.busy = true;
    await this.loadExercises();
    this.busy = false;
  }

  public async loadExercises() {
    if (this.lesson) {
      try {
        this.exercises = await Exercise.getExercisesOfLesson(this.lesson.id);
      } catch (e) {
        this.$bus.$emit(BusEvent.ERROR, 'Could not load exercises', e);
        this.error = true;
      }
    }
  }

  // noinspection JSMethodCanBeStatic
  public slugOf(game_type): string {
    return ExerciseGameType.typeToSlug(game_type);
  }

  public async exerciseMoving({ draggedContext }) {
    // when it starts moving
    if (!this.moving) {
      try {
        this.moving = true;

        if (this.lockManager && this.lockManager.isLocked) {
          await this.lockManager.releaseLock();
          this.lockManager = null;
        }

        this.lockManager = new LockManager(
          this.EXERCISE_SLUG,
          draggedContext.element.id
        );
        this.draggedElement = draggedContext.element;
        await this.tryToLock();
      } catch (e) {
        this.moving = false;
        this.error = true;
        return false;
      }
    }
  }

  public async exerciseDropped(e) {
    await this.tryToLock();
    if (this.draggedElement) {
      this.draggedElement.order = e.newIndex;
      await this.draggedElement.save();
    }
    this.draggedElement = null;
    this.moving = false;

    if (this.lockManager && this.lockManager.isLocked) {
      await this.lockManager.releaseLock();
      this.lockManager = null;
    }
  }
}
